import axios from 'axios';

const state = {
    token: false,
    permissions: [],
    trial: true
};

const getters = {
    isAuthenticated: state => state.token,
    isTrial: state => state.trial,
    getUserPermissions: state => state.permissions,
};

const actions = {
    authRequest({commit}, { username, password }) {
        return new Promise((resolve, reject) => {
            axios({ url: 'login', data: { username, password }, method: 'POST' })
                .then(resp => {
                    commit("authSuccess", resp.data)
                    commit("setProfile", resp.data.profile)
                    resolve(resp)
                })
                .catch(err => {
                    commit("authFailure")
                    commit("setProfile", {})
                    reject(err)
                })
        })
    }, 
    logoutRequest(context){
        return new Promise((resolve) => {
            axios({ url: 'logout', method: 'POST' })
                .then(() => {
                    context.commit("logout")
                    resolve(true)
                })
                .catch(() => {
                    context.commit("logout")
                    resolve(true)
                })
        })
    }
};

const mutations = {
    authSuccess(state, response) {
        state.token = true
        state.permissions = response.permissions
        state.trial = response.trial
    },
    authFailure(state) {
        state.token = false
        state.permissions = []
    },
    logout(state) {
        state.token = false
        state.permissions = []
    },
    setProfile: (state, profile) => (state.profile = profile) // TODO set rootstate profile
}

export default {
    state,
    actions,
    mutations,
    getters
};


